import { render, staticRenderFns } from "./ContractsRenovation.vue?vue&type=template&id=050f2df6&scoped=true&"
import script from "./ContractsRenovation.vue?vue&type=script&lang=js&"
export * from "./ContractsRenovation.vue?vue&type=script&lang=js&"
import style0 from "./ContractsRenovation.vue?vue&type=style&index=0&id=050f2df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050f2df6",
  null
  
)

export default component.exports